import { render, staticRenderFns } from "./BlocUser.vue?vue&type=template&id=652684f2&scoped=true"
import script from "./BlocUser.vue?vue&type=script&lang=js"
export * from "./BlocUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652684f2",
  null
  
)

export default component.exports